/** @typedef {'all' | 'docs' | 'xls' | 'images' | 'document'} DocumentCategoryFilter */

/** @typedef {{ id: string, name: string, category: Exclude<DocumentCategoryFilter, 'all'>, updatedAt: string, sizeLabel: string }} DocumentItem */

/** @type {{ id: DocumentCategoryFilter, label: string }[]} */

export const DOCUMENT_CATEGORY_PILLS = [
  { id: 'all', label: 'All' },
  { id: 'docs', label: 'Docs' },
  { id: 'xls', label: 'Xls' },
  { id: 'images', label: 'Images' },
  { id: 'document', label: 'Document' },
]

/** @type {DocumentItem[]} */
